import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NavioConfetti, NoddiCard, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useRef } from 'react';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { TireOfferConfirmationText } from './TireOfferConfirmationText';

export const ConfirmationSection = ({ invoicedPayment, slug }: { invoicedPayment?: boolean; slug?: string }) => {
  const { brandEmail } = useCurrentBrand();

  const animationRef = useRef<HTMLDivElement>(null);

  const confirmationText = invoicedPayment ? t`Order is confirmed!` : t`Order is confirmed and paid!`;

  return (
    <>
      <NavioConfetti triggerRef={animationRef} pieceCount={60} duration={3.5} />
      <div className='flex w-full max-w-2xl flex-col items-center gap-6'>
        {/* Success Icon Header */}
        <div className='flex flex-col items-center gap-5'>
          <div ref={animationRef} className='flex items-center justify-center rounded-full bg-green-50 p-2'>
            <NoddiIcon name='CircleCheck' size='xLarge' className='fill-green-500 text-white' />
          </div>
          <h1 className='text-center text-3xl font-bold text-primary md:text-4xl'>{confirmationText}</h1>
        </div>

        {/* Next Steps Content */}
        {slug && <TireOfferConfirmationText slug={slug} />}

        {/* Contact Information */}
        <NoddiCard variant='secondary' className='w-full'>
          <Trans>In the meantime, if you have any questions, contact us at {brandEmail}</Trans>
        </NoddiCard>

        {/* Close Button */}
        <div className='flex w-full justify-end'>
          <NoddiLink to={customerRoutes.homepage.getPath()}>
            <Trans>Close</Trans>
          </NoddiLink>
        </div>
      </div>
    </>
  );
};
